import { Component, EventEmitter, Input, Output, } from '@angular/core';
import { CalendarEventModel } from 'src/app/core/models/calendar/calendar.model';
import { AiApiService } from 'src/app/core/services/ai-api.service';
import { AIChatEnum } from 'src/app/core/enums/ai-chat-enum';
import { AIChatModel } from 'src/app/core/models/aiChat/ai-chat.model';
import { DomSanitizer } from '@angular/platform-browser';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { RagChatCompletionRequestModel } from 'src/app/core/models/aiChat/rag-chat-completion-request.model';
import { EntityTypeEnum } from 'src/app/core/enums/entity-type-id-enum';
import { Observable } from 'rxjs';
import { ChatStreamingModel } from 'src/app/core/models/aiChat/chat-streaming.model';
import { ChatRagStreamingModel } from 'src/app/core/models/aiChat/chat-rag-streaming.model';
import { FileUploadModel } from 'src/app/core/models/file/file-upload-model';

import { ToasterNotificationService } from 'src/app/core/services/toaster-notification.service';
import { AIChatModalService } from 'src/app/core/services/modal-services/ai-chat-modal.service';
import { GlobalComponent } from 'src/app/global-component';

@Component({
  selector: 'app-aichat-box',
  templateUrl: './aichat-box.component.html',
  styleUrls: ['./aichat-box.component.scss']
})

export class AIChatBoxComponent {

  messageTypeEnum = MessageTypeEnum;
  userInputMessage: string | undefined = undefined;

  selectedMessageType: MessageTypeEnum | undefined = undefined;


  EnumAIChat = AIChatEnum;
  loadingResponse: boolean = false;
  color?: any;
  routerLinkTerms = '/pages/terms-condition';
  routerLinkPrivacy = '/pages/privacy-policy';
  routerLinkLearnMore = '/pages/blogs';

  animateOut: boolean = false;

  textReader: Observable<any> | undefined = undefined;

  public config = {
    toolbar: [],
    plugins: [],
    htmlOutput: true,
    showHTML: false,
    htmlAttributes: {},
    htmlRawContent: true,

  }
  suggestionsModel?: { title: string, subtext: string }[] = undefined
  tags: string[] = [GlobalComponent.defaultTagList[0]];


  @Input() suggestionsHidden: boolean = true;
  @Input() predefinedTags: string[] | undefined = undefined;
  @Input() modalName: string | undefined = undefined;
  @Input() modalEntityId: string | undefined = undefined;
  @Input() modalEntityType: EntityTypeEnum | undefined = undefined;
  @Input() modalFileId: string | undefined = undefined;
  @Input() showVideo: boolean = true;
  @Input() userAvatar: any;
  @Input() messageHistory: AIChatModel[] = []
  @Output() modelUpdated = new EventEmitter<CalendarEventModel | undefined | boolean>();
  @Output() modelDeleted = new EventEmitter<undefined | boolean>();

  constructor(
    protected modalRef: NgbActiveModal,
    protected toasterNotificationService: ToasterNotificationService,
    protected aiApiService: AiApiService,
    protected aiChatModalService: AIChatModalService,
    private sanitizer: DomSanitizer,
  ) {
  }

  ngOnInit() {
    this.color = document.documentElement.getAttribute('data-layout-mode');

    if (this.modalEntityId !== undefined) {
      this.suggestionsModel = [
        {
          title: "List all injuries in table format.",
          subtext: ``
        },
        {
          title: "List all references to chronic pain in table format.",
          subtext: ``
        },
        {
          title: "List all references to psychological injuries in table format",
          subtext: ``
        },
        {
          title: "List anything pertaining to ADL, or daily living activities",
          subtext: ``
        },
        {
          title: "Are their any pre-existing condition before the date of accident",
          subtext: ``
        }
      ]
    }


    if (this.predefinedTags !== undefined && this.predefinedTags.length > 0) {
      this.tags = this.tags.concat(this.predefinedTags)
    }
  }

  ngOnDestroy() {
    this.modalEntityId = undefined;
    this.clearChat();
  }


  triggerAnimation() {
    this.animateOut = true;
  }

  askSuggestion(message: string | undefined) {
    if (message) {
      this.userInputMessage = message;
      this.addUserMessageAsync();
    }
  }

  copyMessage(message: string | undefined) {
    if (message) {
      if (!navigator.clipboard) {
        this.toasterNotificationService.showError("Unable to copy, to clipboard", "Error")
      } else {
        navigator.clipboard.writeText(message)
        this.toasterNotificationService.showSuccess("Message copied to clipboard", "Success")
      }
    }
  }

  close() {
    this.aiChatModalService.closeModal();
  }

  cancelRequest() {

    if (this.messageHistory[(this.messageHistory.length - 1)].message === undefined || this.messageHistory[(this.messageHistory.length - 1)].message!.length === 0) {
      this.messageHistory[(this.messageHistory.length - 1)].message = "Request Cancelled. "
    }

    this.messageHistory[(this.messageHistory.length - 1)].disableLikeButtons = false;

    this.aiApiService.abortReader();
    this.loadingResponse = false;
  }

  likeMessage(message: AIChatModel, status: boolean) {
    message.liked = status;
    if (message.id && message.liked !== undefined) {
      this.aiApiService.setLikeStatus(message).subscribe(() => { });
    }
  }

  presetMessages(messageType: MessageTypeEnum) {
    if (this.loadingResponse === false) {
      this.selectedMessageType = messageType;
      this.messageHistory = [];
      switch (messageType) {
        case MessageTypeEnum.HowTo:
          this.suggestionsModel = [{
            title: "How does MyFile work?",
            subtext: "Learn how to use MyFile to request documents."
          },
          {
            title: "How long does it take for me to get the requested documents?",
            subtext: "Discover how long it usually takes to receive your requested records."
          },
          {
            title: "How do I register new users, and clients?",
            subtext: "Learn how to invite users and clients to MyFile."
          }]
          this.tags = [GlobalComponent.defaultTagList[0], GlobalComponent.defaultTagList[2]]
          break;
        case MessageTypeEnum.ReleaseNotes:
          this.suggestionsModel = [{
            title: 'What are some of the new release features?',
            subtext: 'Learn about the new features recently added to MyFile.'
          },
          {
            title: 'Where can I find the new features?',
            subtext: 'Learn where the new features can be found'
          },
          {
            title: 'Where can I find the new features?',
            subtext: 'Learn where the new features can be found'
          }]
          this.tags = [GlobalComponent.defaultTagList[0], GlobalComponent.defaultTagList[1]]
          break;
        case MessageTypeEnum.Faq:
          this.suggestionsModel = [

            {
              title: "Can I obtain physical copies of my requested documents?",
              subtext: "Find out if you can get hard copies of your records and how to do so."
            },
            {
              title: "How does the requisition process work",
              subtext: "Learn how to the MyFile requisitions of documents process works."
            },
            {
              title: "How is user data protected?",
              subtext: "Find out about the measures in place to ensure your information remains secure and private."
            }]
          this.tags = [GlobalComponent.defaultTagList[0], GlobalComponent.defaultTagList[3]]
          break;
      }
      this.userInputMessage = undefined;
    }

  }



  addUserMessageAsync() {
    if (this.userInputMessage && this.userInputMessage.length >= 2) {
      this.userInputMessage = this.userInputMessage.replace(/^\s+|\s+$/g, '');

      this.messageHistory.push({ message: `${this.userInputMessage}`, messageType: AIChatEnum.Question, time: new Date() });
      this.scrollToBottom();
      this.loadingResponse = true;

      var messagePostModel: ChatStreamingModel = {
        messageInput: this.userInputMessage,
        tags: []
      }

      if (this.tags !== undefined && this.tags.length > 0) {
        messagePostModel.tags = this.tags;
      }

      if (this.modalFileId) {
        var messagePostRagModel: ChatRagStreamingModel = {
          chatCompletionRequest: messagePostModel,
          loadEntityFileRequest: {
            tags: [],
            fileId: this.modalFileId,
            getFileList: {
              entityId: this.modalEntityId,
              entityTypeId: this.modalEntityType,
              isIcon: false,
              fileUpload: new FileUploadModel()
            }
          }
        }
        this.textReader = this.aiApiService.postChatRagStreaming(messagePostRagModel);
      } else {
        this.textReader = this.aiApiService.postChatStreaming(messagePostModel);
      }

      var stopReaderFlag: boolean = false;
      var receivedId: boolean = false;
      this.messageHistory.push({ message: ``, messageType: AIChatEnum.Response, time: Date.now(), disableLikeButtons: true });
      if (this.textReader !== undefined) {
        this.textReader.subscribe((responseText) => {

          if (responseText === true) {
            this.loadingResponse = false;
          } else if (responseText === false) {
            this.loadingResponse = false;

            if ((this.messageHistory[(this.messageHistory.length - 1)].message !== undefined) || (this.messageHistory[(this.messageHistory.length - 1)].message!.length === 0)) {
              this.messageHistory[(this.messageHistory.length - 1)].message = `The AI Server is currently not available to process your request. Please contact the MyFile Customer service team at customerservice@myfile.ca.`;
            } else {
              this.messageHistory.push({ message: `The AI Server is currently not available to process the rest of your request. Please contact the MyFile Customer service team at customerservice@myfile.ca.`, messageType: AIChatEnum.Response, time: Date.now() });
            }

          } else if (responseText === null) {
            this.loadingResponse = false;
          } else {

            this.loadingResponse = true;

            if (receivedId == true) {
              this.messageHistory[(this.messageHistory.length - 1)].id = responseText;
              this.messageHistory[(this.messageHistory.length - 1)].disableLikeButtons = false;
              receivedId = false;
            }

            if (responseText === '**ENDOFSTREAM') {
              stopReaderFlag = true;
              receivedId = true;
            }

            if (stopReaderFlag != true) {

              this.messageHistory[(this.messageHistory.length - 1)].message = `${this.messageHistory[(this.messageHistory.length - 1)].message}${responseText}`;

              this.messageHistory[(this.messageHistory.length - 1)].time = Date.now();
              this.scrollToBottom();
            }

          }
        });
      }
      this.userInputMessage = undefined;
    } else if (this.userInputMessage && (this.userInputMessage.length === 1 || this.userInputMessage.length === 0)) {
      this.toasterNotificationService.showError("Please enter at least 2 characters", "Error")
    }
  }

  //regular way - no streaming
  .0() {
    if (this.userInputMessage && this.userInputMessage.length > 0) {

      this.userInputMessage = this.userInputMessage.replace(/^\s+|\s+$/g, '');

      this.messageHistory.push({ message: `${this.userInputMessage}`, messageType: AIChatEnum.Question, time: new Date() });
      this.scrollToBottom();
      this.loadingResponse = true;

      var messagePostModel: RagChatCompletionRequestModel = {
        messageInput: this.userInputMessage,
        entityTypeId: this.modalEntityType,
        entityId: this.modalEntityId!,
        fileId: this.modalFileId
      }

      if (messagePostModel.entityId == undefined) {
        this.aiApiService.postAiChat(messagePostModel).subscribe((response: AIChatModel | undefined) => {
          if (response !== undefined && response.items) {
            response.message = `${response.items[0].text}`;
            response.time = Date.parse(`${response.modifiedDate}`);
            response.liked = false;
            response.messageType = AIChatEnum.Response;
            this.messageHistory.push(response);
            this.scrollToBottom();
          }
          this.loadingResponse = false;
        })
      } else {
        this.aiApiService.postAiChatRag(messagePostModel).subscribe((response: AIChatModel | undefined) => {
          if (response !== undefined && response.items) {
            this.messageHistory.push({ message: `${response.items[0].text}`, messageType: AIChatEnum.Response, time: Date.parse(response.metadata?.modifiedDate!), liked: false });
            this.scrollToBottom();
          }
          this.loadingResponse = false;
        })
      }

      this.userInputMessage = undefined;
    }
  }

  clearChat(showMessage?: boolean) {

    if (this.loadingResponse) {
      this.toasterNotificationService.showError("Cannot start new chat while loading message", "Error")
    } else {
      this.selectedMessageType = undefined;
      this.modalName = undefined;

      this.messageHistory = [];
      this.tags = [GlobalComponent.defaultTagList[0]];
      if (this.modalEntityId == undefined) {
        this.suggestionsModel = undefined;
        this.modalEntityId = undefined;
        this.modalEntityType = undefined;
        this.modalFileId = undefined;
      }

      if (showMessage) {
        this.toasterNotificationService.showSuccess("New chat session started", "Success")
      }
    }
  }

  testAsync() {
    this.textReader = this.aiApiService.getAsync();
    this.messageHistory.push({ message: ``, messageType: AIChatEnum.Response, time: Date.now() });
    if (this.textReader !== undefined) {
      this.textReader.subscribe((responseText) => {
        if (responseText === true) {
          this.loadingResponse = false;
        } else if (responseText === false) {
          this.loadingResponse = false;
          this.messageHistory.push({ message: `An error occurred, message only partially received`, messageType: AIChatEnum.Response, time: Date.now() });
        } else {
          this.loadingResponse = true;
          this.messageHistory[(this.messageHistory.length - 1)].message = `${this.messageHistory[(this.messageHistory.length - 1)].message} ${responseText}`;
          this.messageHistory[(this.messageHistory.length - 1)].time = Date.now();
          this.scrollToBottom();
        }
      });
    }
  }

  profilePhotoPNGTransform() {
    if (this.userAvatar) {
      return this.sanitizer.bypassSecurityTrustResourceUrl(`data:image/png;base64, ${this.userAvatar}`);
    }
    return 'assets/images/users/user-dummy-img.jpg';
  }

  scrollToBottom(): void {
    setTimeout(() => {
      var container = document.getElementById('chat-conversation');
      container!.scrollTop = container!.scrollHeight;
    }, 100);

  }

}

export enum MessageTypeEnum {
  HowTo = 0,
  ReleaseNotes = 1,
  Faq = 2,
}
